const schedule_data = [
    {
        id:1,
        day: "Day 1", 
        date: "April 4th", 
        programs: [
            {
                id:"ap21",
                heading: "Arrivals",
                subheading: "Arrival of all participant to the conference venue",
                vessel: "Everyone",
                time: "7:00am - 10:00am"
            },
            {
                id:"ap22",
                heading: "Registration",
                subheading: "Registration of all participant and allocation of rooms",
                vessel: "Bro. Subomi and Bro. Lekan",
                time: "10:00am - 11:00am"
            },
            {
                id:"ap26",
                heading: "Praise and Worship",
                subheading: "Praise and worship session to start the conference",
                vessel: "...",
                time: "11:00am - 11:30am"
            },
            {
                id:"ap25",
                heading: "Synposium: Break-out Session",
                subheading: "Rasing God's Generals, The Days of Your Youth, Rasing Children in Mission",
                vessel: "...",
                time: "11:30am - 1:30pm"
            },
            {
                id:"ap27",
                heading: "Main Lecture 1",
                subheading: "Get Up and Walk: (John 5:1-15)",
                vessel: "Bro. Abel",
                time: "2:30pm - 4:30pm"
            },
            {
                id:"ap28",
                heading:"Testimony Writing",
                subheading: "Write reflections on the messages",
                vessel: "Everyone",
                time: "4:20pm - 6:30pm"
            },
            {
                id:"ap29",
                heading: "Mission Report & Testimony Sharing",
                subheading: "Report on the mission field and life testimony sharing",
                vessel: "...",
                time: "7:30pm - 9:30pm"
            },
            {
                id:"ap30",
                heading: "Prayer Session and Announcement",
                subheading: "Prayer time and general announcement",
                vessel: "...",
                time: "9:30pm"
            }
        ]
    }, 
    {
        id:2,
        day: "Day 2", 
        date: "April 5th", 
        programs: [
            {
                id:"ap31",
                heading: "Morning Devotion and prayer",
                subheading: "...",
                vessel: "Everyone",
                time: "7:00am - 7:30am"
            },
            {
                id:"ap33",
                heading: "Group Bible Study",
                subheading: "Remain in Jesus (John 15:1-17)",
                vessel: "Everyone",
                time: "9:00am - 11:00am"
            },
            {
                id:"ap34",
                heading: "Main Lecture 2",
                subheading: "Remain in Jesus (John 15:1-17)",
                vessel: "Br. Favour Henry",
                time: "11:10am - 1:00pm"
            },
            {
                id:"ap37",
                heading: "Testimony writing",
                subheading: "Write reflections on the messages",
                vessel: "Everyone",
                time: "2:30pm - 4:30pm"
            },
            {
                id:"ap57",
                heading: "Sports",
                subheading: "Football fellowship",
                vessel: "Everyone",
                time: "4:30pm - 6:30pm"
            },
            {
                id:"ap236",
                heading: "Testimony Sharing",
                subheading: "Life testimomy sharing & other presentation",
                vessel: "...",
                time: "9:30pm - 10:30pm"
            },
            {
                id:"ap38",
                heading: "Prayer Session and Announcement",
                subheading: "Prayer time and general announcement",
                vessel: "...",
                time: "9:30pm"
            },
        ]
    }, 
    {
        id:3,
        day: "Day 3", 
        date: "April 6th", 
        programs: [
            {
                id:"ap41",
                heading: "Morning Devotion and prayer",
                subheading: "...",
                vessel: "Everyone",
                time: "7:00am - 7:30am"
            },
            // {
            //     id:"ap42",
            //     heading: "Breakfast",
            //     subheading: "...",
            //     vessel: "Everyone",
            //     time: "7:30am"
            // },
            {   
                id:"ap43",
                heading: "Group Bible Study",
                subheading: "THE VISION: WHO SHALL GO FOR US? (Isaiah 6:1-8)",
                vessel: "Everybody",
                time: "9:00am - 11:00am"
            },
            {   
                id:"ap44",
                heading: "SWS Message",
                subheading: "THE VISION: WHO SHALL GO FOR US? (Isaiah 6:1-8)",
                vessel: "Bro. Isaac Adetona",
                time: "11:10am - 1:00pm"
            },
            {   
                id:"ap45",
                heading: "Closing Remarks & Charge",
                subheading: "...",
                vessel: "Ps. Abraham",
                time: "1:00pm - 2:30pm"
            },
            {   
                id:"ap46",
                heading: "Go to mission field",
                subheading: "Depature from conference venue",
                vessel: "Everyone",
                time: "2:30pm"
            }
        ]
    }, 
]

export default schedule_data